import { Injectable } from '@angular/core';

declare global {
    interface Window {
        dataLayer: any;
    }
}

@Injectable({
    providedIn: 'root',
})
export class GtmService {
    public pushUserProfile(identityType: string, userId: string) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'user_profile_loaded',
            identityType: identityType,
            userId: userId,
            userProfileLoaded: true,
        });
    }
}
